import React from "react";
import { FormGroup, ModalBody, ModalHeader, Input, Label, Button, Form } from "reactstrap";
import SimpleReactValidator from "simple-react-validator";
import { addSubExpertise, updateSubExpertise} from "../../../services/expertizeService";
import { notifyError, notifySuccess } from "../../../utils/utils";
import Loader from "../../../utils/Loader";

class AddSubExpertise extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            subexpertise: "",
            expertise_master_id:"",
            loading: false
        };

        this.validator = new SimpleReactValidator({
            locale: 'en', messages:{}, autoForceUpdate: this,
            subexpertise: {
                message: "Sub Expertise name contains only Alphabet, Numbers and Symbols ,-'[]()&",
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val,  /^[\w&.,'/\s/g\[\]()\-]+$/)
                }
            }
        });

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        if(!this.validator.allValid()){
            this.validator.showMessages();
            this.forceUpdate();
            return;
        }
        const data = { sub_expertise_name: this.state.subexpertise, expertise_master_id: this.state.expertise_master_id};

        this.setState({ loading: true });
        if(this.props.isEditing) {
            updateSubExpertise(this.state.id, data).then(res => this.handleResponse(res.data))
        } else {
            addSubExpertise(data).then(res => this.handleResponse(res.data)); 
        }
    }

    handleResponse(data) {
        console.log(data);
        if(data.status) {
            notifySuccess(data.message);
            setTimeout(() => {
                this.props.toggle();
                this.props.reload();
            }, 1000);
        } else {
            this.setState({ loading: false });
            notifyError(data.message);
        }
    }

    componentDidMount(){
        this.setState({
            expertiseOptions: this.props.expertiseOptions
        });
        if(this.props.isEditing){   
            this.setState({
                expertise_master_id: this.props.subexpertise.expertise_master_id,
                subexpertise: this.props.subexpertise.sub_expertise_name,
                id: this.props.subexpertise.sub_expertise_id,     
            });
        }
    }

    render() {
        this.validator.purgeFields();

        const { subexpertise, expertise_master_id, expertiseOptions } = this.state;

        return(

            <React.Fragment>
                {/* <div className="page-content">
                    <Container fluid> */}
                        <ModalHeader toggle={() => this.props.toggle()}> 
                            {this.props.isEditing ? "Edit" : "Add"} Sub Expertise
                        </ModalHeader>
                        <ModalBody>
                            <Form onSubmit={this.handleSubmit} autoComplete="off">
                                <FormGroup>
                                    <Label>Expetise</Label>
                                    <Input
                                        type="select"
                                        name="expertise_master_id"
                                        value={expertise_master_id}
                                        onChange={e => {
                                            this.setState({
                                                expertise_master_id: e.target.value
                                            });
                                        }}
                                    >
                                        <option value="">Select</option>
                                        {expertiseOptions && expertiseOptions.map((x,i) =>
                                            <option key={i} value={x.expertise_id}>{x.expertise_name}</option>
                                        )}
                                    </Input>
                                    <span className="text-danger">
                                        {this.validator.message('Expertise', expertise_master_id, 'required')}
                                    </span>
                                </FormGroup>
                                

                                <FormGroup>
                                    <Label>Sub Expertise</Label>
                                    <Input
                                        type="text"
                                        name="subexpertise"
                                        value={subexpertise}
                                        onChange={e => {
                                            this.setState({
                                                subexpertise: e.target.value
                                            });
                                        }}
                                    />
                                    <span className="text-danger">
                                        {this.validator.message('sub expertise name', subexpertise, 'required|min:2|max:30|subexpertise')}
                                    </span>
                                </FormGroup>

                                <FormGroup className="pull-right">
                                {
                                    this.state.loading
                                        ?
                                        <Loader />
                                        // <Spinner style={{ width: '3rem', height: '3rem' }}  color="primary" />
                                        :
                                        <Button color="success" type="submit">Submit</Button> 
                                }
                                </FormGroup>
                            </Form>
                        </ModalBody>
                    {/* </Container>
                </div> */}
            </React.Fragment>
        )
    }
}

export default AddSubExpertise;